
* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  --flex-basis: 50%;
  font-size: var(--body-size-medium);
}

.wrapper {
  padding: 2px;
}

.clickable:hover,
.clickable:hover * {
  .item-info {
    cursor: pointer;
    color: var(--blue-layout-400-primary);

    .value-tooltip {
      div {
        color: var(--blue-layout-400-primary);
      }
    }
  }
}

.row {
  display: flex;
  align-items: center;
  height: calc(var(--spacer) * 4);

  .item-info {
    align-items: center;
    flex: 1;
    display: flex;
    justify-content: space-between;
    min-width: 0;
    color: var(--body-text-arrows-400);

    .value-tooltip {
      text-align: end;
      flex-basis: calc(var(--flex-basis));
      font-weight: 700;
      div {
        color: var(--main-titles-inputs-600);
        display: contents;
      }
    }

    .label-tooltip {
      text-align: start;
      flex-basis: calc(var(--flex-basis));
      div {
        display: contents;
      }
    }

    .date-tooltip {
      text-align: center;
      flex-basis: calc(var(--flex-basis));
      div {
        display: contents;
      }
    }
  }
}

gz-tooltip {
  .item-name,
  .item-date {
    font-family: var(--font-family-secondary);
    font-size: var(--body-size-large);
  }

  .item-value {
    font-family: var(--font-family-secondary-mono);
    font-size: var(--body-size);
  }
}

.items {
  display: flex;
  flex-direction: column;
}

.row:not(:last-child) {
  border-bottom: 1px solid var(--chart-101-pressed-dividers);
}

#view-all-link {
  // this is needed in order for it to be aligned with the table label
  margin-left: -2px;
  padding-top: calc(2 * var(--spacer));
  padding-bottom: var(--spacer);

  gz-text {
    color: var(--blue-layout-400-primary);
    --font-family: 'Montserrat', sans-serif;
  }

  gz-text:hover {
    color: var(--blue-layout-301-active);
  }
}

.item-score {
  display: flex;
  gap: 8px;
  align-content: center;
  justify-content: space-between;
  flex-wrap: wrap;

  .item-severity-score {
    font-family: var(--font-family-secondary);
  }
}
